import { scrollToId } from '../App';
import "../css/BikeCard.css"

const BikeCard = ({ id, img, name, kms, type, mountain, h_3, h_5, one_day, two_days, three_days, five_days, text, lang }) => {
    return(
        <div className="bike_card" id={id}>
            <img src={img} alt=""/>
            <div data-id="name">{name}</div>
            <div data-id="kms">{kms} {text['km']?.[lang]}</div>
            <div data-id="type">{type}</div>
            <div data-id="mountain">{mountain}</div>
            <div className='money_container'>
                <div>
                    <span>3 {text["hours"]?.[lang]}</span>
                    <span>{h_3}</span>
                </div>
                <div>
                    <span>5 {text["hours"]?.[lang]}</span>
                    <span>{h_5}</span>
                </div>
                <div>
                    <span>{text["one_day"]?.[lang]}</span>
                    <span>{one_day}</span>
                </div>
                <div>
                    <span>{text["two_days"]?.[lang]}</span>
                    <span>{two_days}</span>
                </div>
                <div>
                    <span>{text["three_days"]?.[lang]}</span>
                    <span>{three_days}</span>
                </div>
                <div>
                    <span>{text["five_days"]?.[lang]}</span>
                    <span>{five_days}</span>
                </div>
            </div>
            <span>{text['included_with_every_rental']?.[lang]}</span>
            <p>{text['premium_helmet']?.[lang]}</p>
            <div onClick={() => {
                scrollToId('reserve_block');
                document.getElementById('bike_model').value = id
            }}>{text['book_now']?.[lang]}</div>
        </div>
    )
}

export default BikeCard;